export default __webpack_public_path__ + "static/media/sam-and-karen-windy-beach.64d41643.png";